/**
 * NotificationListPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  Pagination,
} from 'components';
import { Button, DatePicker, Input, Select, Radio, Tag } from 'antd';
import moment from 'moment';

const NotificationListPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '전송 결과',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'전송 완료'}>전송 완료</Radio>
                <Radio value={'전송 예약'}>전송 예약</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '발송 타입',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'전체'}
              options={[
                { label: '전체', value: '전체' },
                { label: '결제 메일', value: '결제 메일' },
                { label: '공지사항', value: '공지사항' },
                { label: '정기배송', value: '정기배송' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
      ],
    },
    {
      label: '발송일',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '회원 아이디',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="회원 아이디를 입력하세요"
                style={{ ...styles.form.input.large }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '메세지 내용',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="메세지 내용을 입력하세요"
                style={{ ...styles.form.input.large }}
              />
            </>
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  for (let i = 0; i < 10; i++) {
    newData.push({
      전송번호: '000000',
      발송타입: '결제 알림',
      발송시간: new Date(),
      아이디: [1, 2, 3, 4, 5, 6, 7, 8].map((item) => `유저아이디${item}`),
      디바이스토큰: 'afnksdngurengaskjnkfsalslfm',
      타이틀: `000님 결제 관련 되어 안내사항 전달드립니다.`,
      푸시알림내용: `결제관련 안내말씀드립니다. 금일 부터 현재 사용 어쩌고 저쩌고어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고 어쩌고 저쩌고`,
      전송결과: i < 4 ? '전송 완료' : '전송 예약',
    });
  }

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>푸시알림 전송내역</Title>

          {/* 검색필터 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40 }}
          >
            <ExpandableContainer borderRadius={4} padding={20}>
              {formItem.map((_item, _index) => (
                <div
                  key={`form_${_index}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 0px',
                  }}
                >
                  <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                    <label>{_item.label}</label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {_item.form.map((_subitem, _subkey) => (
                      <React.Fragment key={`input_${_subkey}`}>
                        {_subitem.input}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </ExpandableContainer>

            {/* 검색/초기화 버튼 */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginTop: 48,
              }}
            >
              <Button
                size="large"
                type="primary"
                style={{ ...styles.button, background: 'var(--primary-color)' }}
              >
                검색
              </Button>
              <Button size="large" style={{ ...styles.button }}>
                초기화
              </Button>
            </div>
            {/* 검색/초기화 버튼 끝 */}
          </Content>
          {/* 검색필터 끝 */}

          {/* 검색결과 */}
          <Content maxWidth={'100%'} borderRadius={4} padding={20}>
            <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
              검색 결과 총 <span>0</span>건
            </h4>
            <Table
              data={newData}
              columns={[
                {
                  title: '전송 번호',
                  key: '전송번호',
                },
                {
                  title: '발송 타입',
                  key: '발송타입',
                  render: (item) => (
                    <span
                      style={{
                        padding: '7px 3px',
                        border: '0.5px solid #B2B2B2',
                        borderRadius: 4,
                      }}
                    >
                      {item}
                    </span>
                  ),
                },
                {
                  title: '발송 시간',
                  key: '발송시간',
                  render: (item) => moment(item).format('YYYY-MM-DD HH:mm:ss'),
                },
                {
                  title: '아이디',
                  key: '아이디',
                  render: (item) =>
                    item.map(
                      (id, i) => `${id}${i + 1 !== item.length ? ', ' : ''}`
                    ),
                  style: {
                    maxWidth: 200,
                    padding: 8,
                  },
                },
                {
                  title: '디바이스 토큰',
                  key: '디바이스토큰',
                  render: (item) => <p style={{ color: '#1749F8' }}>{item}</p>,
                },
                {
                  title: '타이틀',
                  key: '타이틀',
                  render: (item) => (
                    <button
                      style={{
                        border: 'none',
                        background: 'none',
                        textDecoration: 'underline',
                        color: '#1C6BFF',
                        cursor: 'pointer',
                      }}
                    >
                      {item}
                    </button>
                  ),
                },
                {
                  title: '푸시알림 내용',
                  key: '푸시알림내용',
                  width: 300,
                  style: {
                    maxWidth: 500,
                    padding: 8,
                  },
                },
                {
                  title: '전송 결과',
                  key: '전송결과',
                  render: (item) => (
                    <Tag
                      style={{
                        borderColor:
                          item === '전송 완료' ? '#00BB2A' : '#FF881A',
                        color: item === '전송 완료' ? '#00BB2A' : '#FF881A',
                      }}
                    >
                      {item}
                    </Tag>
                  ),
                },
              ]}
            />
            <Pagination total={40} style={{ marginTop: 20 }} />
            <div
              style={{
                marginTop: 40,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Button
                size="large"
                type="primary"
                style={{ background: 'var(--primary-color)' }}
              >
                푸시알림 전송
              </Button>
            </div>
          </Content>
          {/* 검색결과 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default NotificationListPresenter;
